import { createTheme } from "@mui/material";

const theme = createTheme({
    palette: {
        mode: "light",
        primary: {
            main: "#ffffff",
        },
        secondary: {
            main: "#94c120",
        },
        background: {
            default: "#ffffff",
        },
    },
    typography: {
        allVariants: {
            fontFamily: "Tajawal",
        },
    },
});

export default theme;
